import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import { Edit, Block, Settings } from '@mui/icons-material';
import axios from 'axios.js';
import { useToastify } from '../../../hooks/useToastify';
import { useHistory } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface PerfilProps {
  id: number;
  name: string;
  description: string;
  blockedAt: string | null;
}

interface ProfileListProps {
  handleEdit: (id: number) => void;
  refresh: boolean;
  onRefresh: () => void;
  permissions: string[];
}

function ProfileList({ handleEdit, refresh, onRefresh, permissions }: ProfileListProps) {
  const [perfil, setPerfil] = useState<PerfilProps[]>([]);
  const Toast = useToastify();
  const history = useHistory()

  useEffect(() => {
    fetchPerfil();
  }, []);

  useEffect(() => {
    if (refresh) {
      fetchPerfil();
      onRefresh();
    }
  }, [refresh]);

  async function fetchPerfil() {
    try {
      const response = await axios.get('/perfil');
      if (response.status === 200) {
        setPerfil(response.data.perfil);
      }
    } catch (e) {
      console.error(e);
    }
  }

  const handlePressConfigure = (id: number) => {
    history.push(`/profile/config/${id}`)
  }

  const handleBlock = async (id: number, blocked: boolean) => {
    try {
      const response = await axios.post(`/perfil/block/${id}`, {
        block: !blocked
      });

      if (response.status !== 200) {
        throw new Error(response.statusText);
      }

      if (blocked) {
        Toast.show('success', 'Perfil desbloqueado com sucesso!')
      } else {
        Toast.show('success', 'Perfil bloqueado com sucesso!')
      }
      onRefresh();
    } catch (e) {
      console.error(e);
      Toast.show('error', 'Erro ao bloqueador o perfil!')
    }
  }

  return (
    <TableContainer component={Paper} className="tw-p-6 tw-bg-white tw-shadow-md tw-rounded-lg">
      <h2 className="tw-text-xl tw-font-bold tw-mb-4">Perfis Cadastrados</h2>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nome do perfil</TableCell>
            <TableCell>Descrição do perfil</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {perfil && perfil.length > 0 && perfil.map((role) => (
            <TableRow key={role.id}>
              <TableCell>{role.name}</TableCell>
              <TableCell>{role.description}</TableCell>
              <TableCell>
                <IconButton 
                  title={role.blockedAt ? 'Desbloquear' : 'Bloquear'} 
                  color="default" 
                  onClick={() => handleBlock(role.id, !!role.blockedAt)} 
                  disabled={!permissions.includes('edit') || role.id == 1}
                >
                  <Block className={twMerge("", role.blockedAt && "tw-text-[#ED636E]")} />
                </IconButton>
                <IconButton 
                  title='Editar' 
                  color="default" 
                  onClick={() => handleEdit(role.id)} 
                  disabled={!permissions.includes('edit') || role.id == 1}
                >
                  <Edit />
                </IconButton>
                <IconButton 
                  title='Configurar' 
                  color="default" 
                  onClick={() => handlePressConfigure(role.id)} 
                  disabled={!permissions.includes('edit') || role.id == 1}
                >
                  <Settings />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ProfileList;
